import React, {Component} from "react";
import ChannelItem from "../components/elements/channel.item";
import {msg, rd, route, routes, type_channel, type_modal} from "../../vars/rd";
import {connect} from "react-redux";
import CategoryBusiness from "../components/buttons/category.business";
import CategoryTheme from "../components/buttons/category.theme";
import CategoryGenre from "../components/buttons/category.genre";
import {withRouter} from "react-router-dom";
import {$shutils} from "../../libs/snnh/snnh";
import {proxyBy} from "../../modules/func";
import {modalShow} from "../../libs/redux/actions/modal";


class Channel extends Component {
    msg;
    mounted = false;

    noticeTimeout;
    noticeRef;
    noticeMaskRef;

    pickRef;
    pickMaskRef;

    recentRef;
    recentMaskRef;

    constructor(props) {
        super(props);
        this.msg = msg();

        this.state = {
            brandchart: (rd.main.brandlogo !== null),
            main: rd.main,
            notice_current: 0,
            pick_current: 0,
            recent_current: 0,

            left: rd.main.left || {},
            header: rd.main.header || {},
            channel: rd.main.channel || {},
            information: rd.main.information || {},

            pick: rd.main.pick || [],
            recent: rd.main.history || [],
            bbs: rd.main.bbs || []
        }

        // 윈도우 사이즈 변경시 최근재생 롤백
        window.addEventListener("resize", this.recentRollback);
    }

    componentDidMount() {
        this.mounted = true;
        this.setTimeoutNotice();

        // 윈도우 사이즈 변경시 최근재생 롤백
        window.removeEventListener("resize", this.recentRollback);
    }

    componentWillUnmount() {
        this.mounted = false;
        this.clearTimeoutNotice();

        this.noticeRef = null;
        this.noticeMaskRef = null;

        this.pickRef = null;
        this.pickMaskRef = null;

        this.recentRef = null;
        this.recentMaskRef = null;
    }

    // noinspection JSDeprecatedSymbols
    componentWillReceiveProps(nextProps, nextContext) {
        try {
            if(this.mounted && nextProps && nextProps.hasOwnProperty('recent_channel')) {
                /** @type {DaoChannel|null} */
                const data = nextProps.recent_channel.data || null;
                if(data) {
                    // 이전데이터 넣는 법이 어렵네....
                    const channel = data.clone();
                    const prevdata = this.props && this.props.hasOwnProperty('recent_channel') ? this.props.recent_channel.data : null;
                    if(!prevdata || prevdata.channelid !== channel.channelid) {
                        let recent;
                        this.setState(prevState => {
                            recent = prevState.recent;
                            return {
                                recent: []
                            };
                        }, () => {
                            this.setState({recent}, () => {
                            });
                        } );
                    }
                }
            }
        } catch (e) {}
    }

    get dispatch() {
        return this.props.hasOwnProperty('dispatch') ? this.props.dispatch : () => {};
    }

    setTimeoutNotice() {
        this.noticeTimeout = window.setTimeout(() => {
            this.noticeCurrent(this.noticeNextEnable ? this.state.notice_current + 1 : 0);
        }, 5000);
    }

    clearTimeoutNotice() {
        if (this.noticeTimeout) {
            window.clearTimeout(this.noticeTimeout);
        }
        this.noticeTimeout = null;
    }

    /**
     * @returns {number}
     */
    get pickLength() {
        try {
            return (this.state.pick || []).length;
        } catch (e) {
            return 0;
        }
    }

    pickCurrent(pick_current) {
        this.setState({pick_current}, () => {
            if(this.pickRef) {
                const mask = this.pickMaskRef;
                if(mask) {
                    mask.style.top = `${this.pickRef.offsetHeight * pick_current * -1}px`;
                }
            }
        });
    }

    get pickPrevEnable() {
        return this.state.pick_current > 0;
    }

    pickPrev() {
        this.pickCurrent(this.pickPrevEnable ? this.state.pick_current - 1 : this.pickLength - 1);
    }

    get pickNextEnable() {
        return this.state.pick_current < (this.pickLength - 1);
    }

    pickNext() {
        this.pickCurrent(this.pickNextEnable ? this.state.pick_current + 1 : 0);
    }

    recentRollback = () => {
        if(this.mounted && this.state.recent_current !== 0) {
            this.recentCurrent(0);
        }
    }

    get recentData() {
        const data = [];
        let data_element = [];
        (this.state.recent || []).forEach((channel, i) => {
            data_element.push(channel);
            const idx = i + 1;
            if(idx % 2 === 0) {
                data.push(data_element);
                data_element = [];
            }
        });
        if(data_element.length) data.push(data_element);
        return data;
    }

    get recentLength() {
        try {
            return this.recentData.length;
        } catch (e) {
            return 0;
        }
    }

    recentCurrent(recent_current) {
        this.setState({recent_current}, () => {
            if(this.recentRef) {
                const mask = this.recentMaskRef;
                if(mask) {
                    mask.style.left = `${this.recentRef.offsetWidth * recent_current * -1}px`;
                    // 애니메이션 vh 로 설정
                    // mask.style.left = `${82.292 * recent_current * -1}vh`;
                }
            }
        });
    }

    get recentPrevEnable() {
        return this.state.recent_current > 0;
    }

    recentPrev() {
        if(this.recentPrevEnable)
            this.recentCurrent(this.state.recent_current - 1);
    }

    get recentNextEnable() {
        return this.state.recent_current < (this.recentLength - 1);
    }

    recentNext() {
        if(this.recentNextEnable)
            this.recentCurrent(this.state.recent_current + 1);
    }

    get noticeLength() {
        try {
            return (this.state.bbs || []).length;
        } catch (e) {}
        return 0;
    }

    noticePage(e) {
        e.stopPropagation();
        route(routes.notice, '0');
    }

    noticeCurrent(notice_current) {
        this.clearTimeoutNotice();
        if(this.mounted) {
            this.setState({notice_current}, () => {
                if(this.noticeRef) {
                    const mask = this.noticeMaskRef;
                    if(mask) {
                        mask.style.top = (notice_current === this.noticeLength - 1) ? `0px` : `${this.noticeRef.offsetHeight * notice_current * -1}px`;
                    }
                }

                this.setTimeoutNotice();
            });
        }
    }

    get noticeNextEnable() {
        return this.state.notice_current < (this.noticeLength - 1);
    }

    get chart() {
        try {
            return this.state.main.chart || [];
        } catch (e) {}
        return [];
    }

    get chartBiz() {
        try {
            return this.chart && this.chart.hasOwnProperty('biz') ? this.chart.biz : [];
        } catch (e) {}
        return [];
    }

    get chartAll() {
        try {
            return this.chart && this.chart.hasOwnProperty('all') ? this.chart.all : [];
        } catch (e) {}
        return [];
    }

    /**
     * 오브젝트의 Property
     * @param o {Object}
     * @param key {string}
     * @param def {*|null}
     * @returns {*|null}
     */
    property(o, key, def=null) {
        return o && o.hasOwnProperty(key) ? o[key] : def;
    }

    myChannel() {
        route(routes.mychannel);
    }

    mySchedule() {
        // route(routes.myschedule);
        this.dispatch(
            modalShow(
                type_modal.alert,
                {
                    message: this.msg.prepare
                }
            )
        );
    }

    render() {
        return (
            <div className="contents">
                <div className="left">
                    <div className="mobile-wrap">
                        <div className="img-wrap" style={{
                            backgroundImage: `url(${proxyBy(this.property(this.state.left, 'banner', '/images/main-img.png'))})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat' }}>
                            <div className="text">
                                {rd.user.shopName}
                                {this.property(this.state.left, 'text') || '님, 반갑습니다.'}
                            </div>
                        </div>
                        <div className="main-menu">
                            <ul>
                                <li onClick={() => this.myChannel()}>
                                    <img src="/images/icon-mych.png" alt={'내 채널'} />내 채널
                                </li>
                                <li onClick={() => this.mySchedule()} className="disabled">
                                    <img src="/images/icon-schedule.png" alt={'스케쥴'} />스케쥴
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="notice">
                            <div className="notice-icon" onClick={e => this.noticePage(e)}>
                                <img src="/images/icon-notice.png" alt={''} />
                                {this.state.main.bbsNew ? <span className="notice-new">{this.state.main.bbsNew}</span> : null}
                            </div>

                            <div className="notice-wrapper" ref={el => {
                                this.noticeRef = el;
                            }}>
                                <div className="mask-wrap animate" ref={el => {
                                    this.noticeMaskRef = el;
                                }}>
                                    {
                                        !!this.noticeLength ?
                                            this.state.bbs.map((bbs, index) => {
                                                return (
                                                    <div key={index} className="item"
                                                         onClick={() => route(routes.notice, bbs.bbsid)}>
                                                        <div className="notice-wrap">
                                                            <div className="title">{bbs.title}</div>
                                                            <div className="date">{bbs.date_str} ({bbs.week_str})</div>
                                                        </div>
                                                    </div>
                                                );
                                            }) :
                                            <div className="item empty">
                                                <div className="notice-wrap">공지사항이 없습니다.</div>
                                            </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="pdpick">
                            <div className="pdpick-wrap" ref={el => {
                                this.pickRef = el;
                            }}>
                                <h2>PD Pick!</h2>
                                <div className="box" ref={el => {
                                    this.pickMaskRef = el;
                                }}>
                                    {
                                        !!this.pickLength ?
                                            (this.state.pick || []).map(
                                                /**
                                                 * @param channel {{title: string, text: string, lists: DaoChannel}}
                                                 * @param index
                                                 * @returns {JSX.Element}
                                                 */
                                                (channel, index) => {
                                                    const itemChannel = channel.lists;
                                                    itemChannel.headline = this.property(channel, 'text', '');
                                                    return <ChannelItem key={index} data={itemChannel} type={type_channel.pd_pick} />;
                                                }
                                            ) : null
                                    }
                                </div>
                            </div>
                            <div className="rolling-wrap">
                                <div className="dot">
                                    <ul>
                                        {
                                            $shutils.dummyArray(this.pickLength).map(i => {
                                                return (
                                                    <li key={i} className={this.state.pick_current === i ? 'on' : ''} onClick={() => this.pickCurrent(i)}></li>
                                                )
                                            })
                                        }
                                    </ul>
                                </div>
                                <div className="arrow">
                                    <ul>
                                        <li>
                                            <img src="/images/icon-prev.png" onClick={() => this.pickPrev()} alt={'이전'}/>
                                        </li>
                                        <li>
                                            <img src="/images/icon-next.png" onClick={() => this.pickNext()} alt={'다음'}/>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="right">
                    <div className="section section2">
                        <div id={"section-test"}>

                        </div>

                        <div className="recent">
                            <h3>최근 재생한 채널<span><img src="/images/icon-clock.png" alt={''}/> 최대 10개까지 표시됩니다.</span></h3>

                            <div className="recent-wrap" ref={el => {
                                this.recentRef = el;
                            }}>
                                <div className="mask-wrap" ref={el => {
                                    this.recentMaskRef = el;
                                }}>
                                    {
                                        this.recentData.length ?
                                            this.recentData.map((channels, idx) => {
                                                return (<div className="box" key={idx}>
                                                    {
                                                        channels.map((channel, index) => {
                                                            return (
                                                                <ChannelItem key={index} data={channel}
                                                                             type={type_channel.recent}/>
                                                            );
                                                        })
                                                    }
                                                </div>);
                                            }) :
                                            <div className={'mask-wrap empty'}>최근 재생한 채널이 없습니다.</div>
                                    }
                                </div>
                            </div>

                            <div className="rolling-wrap">
                                <ul>
                                    <li className="arrow" onClick={() => this.recentPrev()}>
                                        <img src={`/images/icon-prev-s${this.recentPrevEnable ? '_on' : ''}.png`}
                                             alt={'이전'}/>
                                    </li>
                                    <li className="dot">
                                        <ul>
                                            {
                                                $shutils.dummyArray(this.recentLength).map(i => {
                                                    return (
                                                        <li key={i}
                                                            className={this.state.recent_current === i ? 'on' : ''}
                                                            onClick={() => this.recentCurrent(i)}></li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </li>
                                    <li className="arrow" onClick={() => this.recentNext()}>
                                        <img src={`/images/icon-next-s${this.recentNextEnable ? '_on' : ''}.png`}
                                             alt={'다음'}/>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                    <div className="section">
                        <div className="recommend">
                            <h2>
                                <span>{this.property(this.state.channel, 'name', '고객님')}</span>
                                {this.property(this.state.channel, 'text', '을 위한 오늘의 맞춤 채널')}
                            </h2>
                            <div className="box">
                                {
                                    (this.state.channel && (this.state.channel.lists || []).length) ?
                                        this.state.channel.lists.map((channelRecommand, index) => {
                                            return <ChannelItem key={index} data={channelRecommand.channel}
                                                                type={type_channel.recommand}/>;
                                        }) :
                                        <div className={'item empty'}>
                                            채널정보가 없습니다.
                                        </div>
                                }
                            </div>
                        </div>
                    </div>

                    { /* 실시간 인기차트 */}
                    <div className="section">
                        <div className={`chart ${this.state.brandchart ? 'chart2' : ''}`}>
                            <h2><span>실시간 인기차트</span></h2>
                            {
                                this.state.brandchart ?
                                    (
                                        <div className="list-wrap">
                                            {/* 브랜드차트 */}
                                            <div className="list-box">
                                                <h3><img src="/images/mega-logo.png" alt={''}/> 인기</h3>
                                                <div className="list custom">
                                                    {
                                                        this.chartBiz.map((channel, index) => {
                                                            return (
                                                                <ChannelItem key={index} data={channel}
                                                                             index={index + 1}
                                                                             last={(index + 1) === this.chartBiz.length}
                                                                             type={type_channel.chart_biz}/>
                                                            );
                                                        })
                                                    }
                                                </div>
                                            </div>
                                            {/* 브랜드차트 */}
                                            <div className="list-box">
                                                <h3>전체 인기</h3>
                                                <div className="list">
                                                    {
                                                        this.chartAll.map((channel, index) => {
                                                            return (
                                                                <ChannelItem key={index} data={channel}
                                                                             index={index + 1}
                                                                             last={(index + 1) === this.chartAll.length}
                                                                             type={type_channel.chart} />
                                                            );
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    ) :
                                    (
                                        <div className="list-wrap">
                                            <div className="list">
                                                {
                                                    this.chartAll.map((channel, index) => {
                                                        return (
                                                            <ChannelItem key={index} data={channel} index={index + 1} last={(index + 1) === this.chartAll.length} type={type_channel.chart} />
                                                        );
                                                    })
                                                }
                                            </div>
                                        </div>
                                    )
                            }
                        </div>
                    </div>
                    { /* 실시간 인기차트 */ }

                    <div className="section">
                        <div className="recommend-type">
                            <h2><span>업종별 추천 채널</span></h2>
                            <div className="list">
                                {(rd.category.business || []).map(
                                    /**
                                     * @param category {DaoCategory}
                                     * @param index {number}
                                     * @returns {JSX.Element}
                                     */
                                    (category, index) => {
                                        category.selected = false;
                                        return <CategoryBusiness key={index} is_mine={rd.user.shopBusiness.proid === category.proid} category={category} selected={false}/>;
                                    }
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="section">
                        <div className="theme">
                            <h2><span>테마별 채널</span></h2>
                            <ul className="list">
                                {(rd.category.theme || []).map(
                                    /**
                                     * @param category {DaoCategory}
                                     * @param index {number}
                                     * @returns {JSX.Element}
                                     */
                                    (category, index) => {
                                        return <CategoryTheme key={index} category={category} selected={false}/>;
                                    }
                                )}
                            </ul>
                        </div>
                    </div>
                    <div className="section">
                        <div className="genre">
                            <h2><span>장르별 채널</span></h2>
                            <div className="list">
                                {(rd.category.genre || []).map(
                                    /**
                                     * @param category {DaoCategory}
                                     * @param index {number}
                                     * @returns {JSX.Element}
                                     */
                                    (category, index) => {
                                        return <CategoryGenre key={index} category={category} selected={false}/>;
                                    }
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const channelRecentStateToProps = (state) => ({
    recent_channel: state.recent_channel,
});

export default connect(channelRecentStateToProps)(withRouter(Channel));


// WEBPACK FOOTER //
// ./src/pages/channel/index.jsx